import React, { useEffect } from "react";
import Modal from "components/Modal";
import PostBanner from "components/PostBanner";
import { connect } from "react-redux";
import { togglePostBannerModal } from "stateManagement/reducers/modalReducer";

/**
 * @param {{
 *   showModal: boolean,
 *   toggleModal: Function,
 *   images: { url: string, role: number }[],
 *   properties: any[],
 *   deviceSize: string
 * }} props
 */
const PostBannerModal = (props) => {
    useEffect(() => {
        document.body.style.overflow = props.showModal ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [props.showModal]);

    return (
        <Modal
            isOpen={props.showModal}
            toggleModal={props.toggleModal}
            hideOpenAsPage={true}
            showHeader={false}
            showThreeDotMenu={false}
            modalDialogCustomClass="modal-dialog-md"
            modalContentStyle={{ backgroundColor: "black", marginTop: "100px" }}
            closeIconFill={"#444"}
        >
            <PostBanner
                images={props.images}
                customClass="post-page-banner-modal"
                postPage={true}
                deviceSize={props.deviceSize}
                properties={props.properties}
                useAspectRatio={true}
                rightArrowStyle={{ right: "26px" }}
                leftArrowStyle={{ left: "26px" }}
                imageStyle={{
                    objectFit: "contain",
                    maxHeight: "70vh",
                    width: props.deviceSize === "sm" ? "90%" : "93%"
                }}
                indicatorsWhite={true}
                carouselInnerStyle={{ backgroundColor: "black" }}
                isModal={true}
                currentMedia={props.currentMedia}
            />
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    showModal: state.modalReducer.postBannerModal.showPostBannerModal   ,
    images: state.modalReducer.postBannerModal.images,
    properties: state.modalReducer.postBannerModal.properties,
    deviceSize: state.modalReducer.postBannerModal.deviceSize,
    currentMedia: state.modalReducer.postBannerModal.currentMedia,
});

const mapDispatchToProps = {
    toggleModal: togglePostBannerModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(PostBannerModal);
